export default defineNuxtRouteMiddleware(async () => {
  const user = useUser()
  if (!user.value || user.value.roleId !== 'ADMIN') { return navigateTo('/') }
})
